var map = {
	"./ar.json": [
		7349,
		7349
	],
	"./bg.json": [
		9337,
		9337
	],
	"./bn.json": [
		1158,
		1158
	],
	"./ca.json": [
		8498,
		8498
	],
	"./cs.json": [
		3872,
		3872
	],
	"./de.json": [
		5089,
		5089
	],
	"./en.json": [
		517,
		517
	],
	"./en_RS.json": [
		565,
		565
	],
	"./es.json": [
		7486,
		7486
	],
	"./fa_IR.json": [
		427,
		427
	],
	"./fr.json": [
		1254,
		1254
	],
	"./gl.json": [
		4397,
		4397
	],
	"./hi.json": [
		4993,
		4993
	],
	"./id.json": [
		6831,
		6831
	],
	"./it.json": [
		8415,
		8415
	],
	"./ja.json": [
		8843,
		8843
	],
	"./jv.json": [
		2710,
		2710
	],
	"./kk.json": [
		9072,
		9072
	],
	"./ko.json": [
		3708,
		3708
	],
	"./mn.json": [
		5757,
		5757
	],
	"./mn_MN.json": [
		4125,
		4125
	],
	"./mr.json": [
		8065,
		8065
	],
	"./nl.json": [
		6872,
		6872
	],
	"./pa.json": [
		2097,
		2097
	],
	"./pl_PL.json": [
		2503,
		2503
	],
	"./pt-br.json": [
		3725,
		3725
	],
	"./pt_BR.json": [
		6227,
		6227
	],
	"./ro.json": [
		8865,
		8865
	],
	"./ru.json": [
		2463,
		2463
	],
	"./sq.json": [
		274,
		274
	],
	"./ta.json": [
		2437,
		2437
	],
	"./te.json": [
		8657,
		8657
	],
	"./tr_TR.json": [
		5099,
		5099
	],
	"./ur_PK.json": [
		6331,
		6331
	],
	"./vi.json": [
		8847,
		8847
	],
	"./yi.json": [
		3320,
		3320
	],
	"./zh-cn.json": [
		4554,
		4554
	],
	"./zh.json": [
		2880,
		2880
	],
	"./zh_CN.json": [
		7388,
		7388
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 967;
module.exports = webpackAsyncContext;